<template>
<div class="tab-wrapper">
  <h3 class="mb16">物业交割清单</h3>
  <div class="content" v-if="deliverysInfo">
    <div class="item pt16 pb16">
      <table-list :columns="columns" :show-page="false" :data="deliverysInfo" :loading="loading"></table-list>
    </div>
  </div>
  <delivery-modal  :n="key" @showimg="showImg" :deliverysInfo="subDeliverysInfo" :projectName="projectName" :houseNumber="houseNumber"></delivery-modal>
  <img-show :n="showImgKey" :src="imgSrc"></img-show>
</div>
</template>
 
<script type="text/ecmascript-6">
import { personalDeliveryInfo } from 'api/auditContract'
import TableList from "components/TableList/index"
import DeliveryModal from "./CompanyDeliveryModal"
import ImgShow from 'components/ImgShow/index'

export default {
  props:{
    deliverysInfo:{
      type:Array,
      default:null
    },
    projectName:{
      type:String,
      default:''
    }

    // parentSurrenderFid:{
    //   type:String,
    //   default:''
    // },
    // surrenderFid:{
    //   type:String,
    //   default:null
    // },
    // contractFid:{
    //   type:String,
    //   default:''
    // },
  },
   created(){
    // this.getEnterpriseDeliverys(1)
  },
components:{
  TableList,
  DeliveryModal,
  ImgShow
},
watch:{
  parentSurrenderFid(){
    //this.getEnterpriseDeliverys(1)
  }
},
 data () {
  return {
    contractFid:'',
    houseNumber:'',
    imgSrc:'',
    showImgKey:0,
    key:0,
    subDeliverysInfo:null,
    loading:false,
    columns:[
      {
        type: "index",
        width:60,
        align: "center"
      },
      {
        title: "房间号",
        key: "stockNumber",
        align: "center"
      },
      {
        title: "交割状态",
        key: "deliveryStateCn",
        align: "center"
      },
      {
        title: "操作",
        key: "action",
        align: "center",
        render: (h,params) => {
          return h('a',{
            style:{
              color: '#CFA868',
              cursor: 'pointer'
            },
            on: {
              click: ()=>{
                // 调接口

                this.contractFid=params.row.contractFid
                this.houseNumber =params.row.stockNumber
                personalDeliveryInfo(this.contractFid).then( res => {
                  this.subDeliverysInfo = res.data
                })
                this.key++                
              }
            }
          },'查看')
        }
      }
    ]
  };
 },
 methods:{
   showImg(data) {
      this.imgSrc = data
      this.showImgKey++
    }
 }
}
</script>




